import type { AppRemoteConfig, RawAppRemoteConfig } from '../platform/Platform';
import { rawAppRemoteToAppRemote } from './rawAppRemoteToAppRemote';

/**
 * Default remote config used when remote config is not available
 * Matches the current hardcoded behavior for backward compatibility
 * NOTE: Its not mandatory to keep keys same as DEFAULT_REMOTE_CONFIG, due to remote config has some limitation,
 * Platform load its own remote config format and map into AppRemoteConfig type.
 */
/* eslint-disable @typescript-eslint/naming-convention */
export const DEFAULT_RAW_REMOTE_CONFIG: RawAppRemoteConfig = {
  segment_isTier1: false,
  feature_luckyWheel_adSpins: 2,
  feature_duel_desktopTimeMultiplier: 1.4,
  ads_fallback_xpromoAllowedIos: true,
  ads_fallback_xpromoAllowedAndroid: true,
  feature_tournament_configUrl: '',
  ads_interstitials_useFacebookFlow: true,
  // Mobile Interstitial Ads Config
  ads_interstitials_enabled: true,
  ads_interstitials_firstLevel: 5,
  ads_interstitials_onLoss: true,
  ads_interstitials_lossFrequency: 1,
  ads_interstitials_onWin: true,
  ads_interstitials_winFrequency: 1,
  ads_interstitials_cooldownSeconds: 300,
  ads_interstitials_maxAdsPerSession: 10,
  ads_interstitials_midLevelEnabled: false,
  ads_interstitials_everyXSeconds: 180,
  ads_interstitials_payerCooldownHours: 168, // 7 days
  // Mobile Banner Ads Config
  ads_banner_supported: false,
  ads_banner_enabled: false,
  ads_banner_firstLevel: 1,
  // extra mobile specific config
  app_forceUpdateVersion: '1.10.0',
  app_optionalUpdateVersion: '1.10.0',
  app_allowCheatOption: false,
} as const;

export const DEFAULT_REMOTE_CONFIG: AppRemoteConfig = rawAppRemoteToAppRemote(DEFAULT_RAW_REMOTE_CONFIG);
